import { render } from "./ShopSaleItem.vue?vue&type=template&id=6082937a"
import script from "./ShopSaleItem.vue?vue&type=script&lang=js"
export * from "./ShopSaleItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__